// Furnio BOQ estimator — full multi-room builder, priced live with window.FurnioEngine.
// Vanilla JS re-implementation of the Estimate.dc.html prototype's Component logic.
(function () {
  "use strict";

  var STORAGE_KEY = "furnio-estimate-state-v1";

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    attrs = attrs || {};
    Object.keys(attrs).forEach(function (k) {
      if (k === "class") node.className = attrs[k];
      else if (k === "html") node.innerHTML = attrs[k];
      else node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  function init() {
    var root = document.querySelector("[data-fx-boq]");
    if (!root || !window.FurnioEngine) return;
    var engine = window.FurnioEngine;
    var rates = engine.DEFAULT_RATES;
    var fmt = engine.fmt;

    var roomTabsEl = root.querySelector("[data-fx-room-tabs]");
    var addRoomBtn = root.querySelector("[data-fx-add-room]");
    var rowsEl = root.querySelector("[data-fx-item-rows]");
    var addItemBtn = root.querySelector("[data-fx-add-item]");
    var summaryRoomsEl = root.querySelector("[data-fx-summary-rooms]");
    var grandTotalEl = root.querySelector("[data-fx-grand-total]");
    var grandMetaEl = root.querySelector("[data-fx-grand-meta]");
    var emailLink = root.querySelector("[data-fx-email-link]");
    var resetBtn = root.querySelector("[data-fx-reset]");

    function freshState() {
      return {
        rooms: [{ id: 1, name: "Kitchen", items: [{ id: 1, type: "cabinet", width: "600", height: "850", depth: "580", qty: 1, shutter: "Standard", accessory: "" }] }],
        activeRoom: 1,
        nextItemId: 2,
        nextRoomId: 2,
      };
    }

    var state = freshState();
    try {
      var saved = window.localStorage.getItem(STORAGE_KEY);
      if (saved) state = JSON.parse(saved);
    } catch (e) { /* ignore corrupt/unavailable storage */ }

    function save() {
      try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) { /* ignore */ }
    }

    function activeRoom() {
      var found = null;
      state.rooms.forEach(function (r) { if (r.id === state.activeRoom) found = r; });
      return found || state.rooms[0];
    }

    function roomCalc(room) {
      var price = 0, sft = 0;
      room.items.forEach(function (it) {
        var res = engine.calculateItem(it, rates);
        price += res.price || 0;
        sft += res.sft || 0;
      });
      return { price: price, sft: sft };
    }

    function render() {
      // Room tabs
      roomTabsEl.innerHTML = "";
      state.rooms.forEach(function (room) {
        var calc = roomCalc(room);
        var isActive = room.id === state.activeRoom;
        var removeBtn = el("span", { class: "fx-room-tab__remove" }, []);
        removeBtn.textContent = "✕";
        removeBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          if (state.rooms.length <= 1) return;
          state.rooms = state.rooms.filter(function (r) { return r.id !== room.id; });
          state.activeRoom = state.rooms[0].id;
          save(); render();
        });
        var priceSpan = el("span", { class: "fx-room-tab__price" }, []);
        priceSpan.textContent = fmt(calc.price);
        var tab = el("div", { class: "fx-room-tab" + (isActive ? " is-active" : "") }, [
          document.createTextNode(room.name + " "), priceSpan, removeBtn,
        ]);
        tab.addEventListener("click", function () { state.activeRoom = room.id; save(); render(); });
        roomTabsEl.appendChild(tab);
      });

      // Item rows
      rowsEl.innerHTML = "";
      var room = activeRoom();
      room.items.forEach(function (it, i) {
        var res = engine.calculateItem(it, rates);
        var idx = el("span", { class: "fx-item-row__idx" }, []);
        idx.textContent = String(i + 1).padStart(2, "0");

        var typeSel = el("select", {}, []);
        engine.ITEM_TYPES.forEach(function (t) {
          var opt = el("option", { value: t.value }, []);
          opt.textContent = t.label;
          if (t.value === it.type) opt.selected = true;
          typeSel.appendChild(opt);
        });
        typeSel.addEventListener("change", function () { it.type = typeSel.value; save(); render(); });

        var wIn = el("input", { type: "number", placeholder: "—", value: it.width }, []);
        wIn.addEventListener("input", function () { it.width = wIn.value; save(); render(); });
        var hIn = el("input", { type: "number", placeholder: "—", value: it.height }, []);
        hIn.addEventListener("input", function () { it.height = hIn.value; save(); render(); });
        var dIn = el("input", { type: "number", placeholder: "—", value: it.depth }, []);
        dIn.addEventListener("input", function () { it.depth = dIn.value; save(); render(); });
        var qIn = el("input", { type: "number", value: it.qty }, []);
        qIn.addEventListener("input", function () { it.qty = qIn.value; save(); render(); });

        var shutterSel = el("select", {}, []);
        engine.SHUTTER_OPTIONS.forEach(function (name) {
          var opt = el("option", { value: name }, []);
          opt.textContent = name;
          if (name === it.shutter) opt.selected = true;
          shutterSel.appendChild(opt);
        });
        shutterSel.addEventListener("change", function () { it.shutter = shutterSel.value; save(); render(); });

        var accSel = el("select", {}, []);
        accSel.appendChild(el("option", { value: "" }, [document.createTextNode("— none —")]));
        engine.ACCESSORIES.forEach(function (a) {
          var opt = el("option", { value: a.name }, []);
          opt.textContent = a.name + " — " + fmt(a.price);
          if (a.name === it.accessory) opt.selected = true;
          accSel.appendChild(opt);
        });
        accSel.addEventListener("change", function () {
          it.accessory = accSel.value;
          if (accSel.value) it.type = "accessory";
          save(); render();
        });

        var priceSpan = el("span", { class: "fx-item-row__price" }, []);
        priceSpan.textContent = fmt(res.price);

        var removeBtn = el("button", { type: "button", class: "fx-item-row__remove" }, []);
        removeBtn.textContent = "✕";
        removeBtn.addEventListener("click", function () {
          room.items = room.items.filter(function (x) { return x.id !== it.id; });
          save(); render();
        });

        var row = el("div", { class: "fx-item-row" }, [idx, typeSel, wIn, hIn, dIn, qIn, shutterSel, accSel, priceSpan, removeBtn]);
        rowsEl.appendChild(row);
      });

      // Summary
      summaryRoomsEl.innerHTML = "";
      var grand = 0, grandSft = 0;
      state.rooms.forEach(function (r) {
        var calc = roomCalc(r);
        grand += calc.price;
        grandSft += calc.sft;
        var meta = el("div", { class: "fx-summary-row__meta" }, []);
        meta.textContent = r.items.length + " UNITS · " + calc.sft.toFixed(1) + " SFT" + (calc.sft > 0 ? " · " + fmt(calc.price / calc.sft) + "/SFT" : "");
        var name = el("div", { class: "fx-summary-row__name" }, []);
        name.textContent = r.name;
        var price = el("span", { class: "fx-summary-row__price" }, []);
        price.textContent = fmt(calc.price);
        summaryRoomsEl.appendChild(el("div", { class: "fx-summary-row" }, [el("div", {}, [name, meta]), price]));
      });
      grandTotalEl.textContent = fmt(grand);
      grandMetaEl.textContent = grandSft > 0 ? grandSft.toFixed(1) + " SFT TOTAL" : "";

      var bodyLines = state.rooms.map(function (r) {
        var calc = roomCalc(r);
        return r.name + ": " + fmt(calc.price) + " (" + r.items.length + " units, " + calc.sft.toFixed(1) + " sft)";
      }).join("\n");
      var mailBody = encodeURIComponent(
        "BOQ estimate from furnio.co.in\n\n" + bodyLines + "\n\nTOTAL: " + fmt(grand) + " · " + grandSft.toFixed(1) + " sft\n\nMy details:\nName:\nPhone:\nCommunity/site:"
      );
      emailLink.href = "mailto:sales@furnio.co.in?subject=" + encodeURIComponent("BOQ estimate request") + "&body=" + mailBody;
    }

    addRoomBtn.addEventListener("click", function () {
      var names = ["Kitchen", "Wardrobe", "Living room", "Bedroom", "Study", "Utility"];
      var used = state.rooms.map(function (r) { return r.name; });
      var name = names.filter(function (n) { return used.indexOf(n) === -1; })[0] || ("Room " + state.nextRoomId);
      state.rooms.push({ id: state.nextRoomId, name: name, items: [{ id: state.nextItemId, type: "cabinet", width: "", height: "", depth: "", qty: 1, shutter: "Standard", accessory: "" }] });
      state.activeRoom = state.nextRoomId;
      state.nextRoomId += 1;
      state.nextItemId += 1;
      save(); render();
    });

    addItemBtn.addEventListener("click", function () {
      var room = activeRoom();
      room.items.push({ id: state.nextItemId, type: "cabinet", width: "", height: "", depth: "", qty: 1, shutter: "Standard", accessory: "" });
      state.nextItemId += 1;
      save(); render();
    });

    if (resetBtn) {
      resetBtn.addEventListener("click", function () {
        if (!window.confirm("Clear this BOQ and start over?")) return;
        state = freshState();
        save(); render();
      });
    }

    render();
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
